import type { OpportunityDetail, OpportunityFeedFilters, OpportunityFeedItem } from './types'
import { authApiClient } from '~/lib/api-client'

const opportunitiesClient = (authApiClient as any).api.opportunities

async function parseJson<T>(response: Response): Promise<T> {
  if (!response.ok) {
    throw response
  }
  return response.json() as Promise<T>
}

export async function listOpportunities(filters: OpportunityFeedFilters = {}) {
  const response = await opportunitiesClient.$get({
    query: filters,
    header: { Authorization: '' },
  })
  return parseJson<OpportunityFeedItem[]>(response)
}

export async function getOpportunity(opportunityId: string) {
  const response = await opportunitiesClient[':opportunityId'].$get({
    param: { opportunityId },
    header: { Authorization: '' },
  })
  return parseJson<OpportunityDetail>(response)
}
